import LegacyMount from "../../components/common/LegacyMount";
import type { Runtime } from "../../components/common/runtime";

// Plan review and block production, still drawn by `components/report/report-view.ts`.
export default function ReportGeneration({ runtime, path, revision, navigate }: {
  runtime: Runtime; path: string; revision: number; navigate: (path: string) => void;
}) {
  return <LegacyMount runtime={runtime} path={path} revision={revision}
    render={() => runtime.report.renderReport(navigate)} />;
}
